import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetSBSMonitoringHistoryColumns } from './useGetSBSMonitoringHistoryColumns';
import SBSMonitoringHistoryExpandable from './SBSMonitoringHistoryExpandable';

import useScreenSize from 'hooks/Screen/useScreenSize';
import useGetSBSMonitoringHistory from 'hooks/Traps/SRBMTraps/useGetSRBMMonitoringHistory';
import FilterTrapHistoryDataTable from 'components/DevicesDetail/MCT/HistoryTable/FilterTrapHistoryDataTable';
import { SRBMMonitoringHistoryData } from 'api/traps/SRBMTraps/types';

interface SBSMonitoringHistoryCardProps {
  slug: string;
}

const SBSMonitoringHistoryCard: React.FC<SBSMonitoringHistoryCardProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetSBSMonitoringHistory(slug || '');
  const columns = useGetSBSMonitoringHistoryColumns();
  const searchFields = ['msg_token', 'date_time', 'crm_date_time', 'bait_filling'];
  const { isNotLargeDesktop } = useScreenSize();
  const { t } = useTranslation();

  useEffect(() => {
    refetch();
  }, [page, search, ordering, refetch]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="card shadow-lg">
          <div className="card-body" style={{ minHeight: '570px' }}>
            <FilterTrapHistoryDataTable<SRBMMonitoringHistoryData>
              columns={columns}
              data={data || []}
              onChangePage={setPage}
              onChangeFilterParams={setQueryParam}
              onChangeSearch={setSearch}
              searchFields={searchFields}
              title={t('SBSDetail.BaitStationActivity.tableTitle')}
              titlePerPage={t('MCTDetail.TrapHistoryCard.titlePerPage')}
              isLoading={isLoading}
              expandableRows={isNotLargeDesktop}
              expandableRowsComponent={row => <SBSMonitoringHistoryExpandable data={row.data} />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SBSMonitoringHistoryCard;
